import type { GetPhoto200Response } from '@/utils/api/api';

/**
 * ミーティング出席者
 */
export interface Attendee {
  id: string;
  type: string;
  muted: boolean;
  signalStrength: number;
  speaking: boolean;
  isContentAttendee: boolean;
}

/** ユーザー種別 */
export const UserType = {
  CREW: 'crew',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ADMIN: 'admin',
  UNKNOWN: 'unknown'
} as const;
export type UserType = (typeof UserType)[keyof typeof UserType];

/** Chimeイベント */
export interface ChimeEvent {
  event: string | undefined;
  meetingStatus: string | undefined;
}

/** 画面フォーカス */
export const VideoFocus = {
  DEFAULT: 'default',
  CREW: 'crew',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  CONTENT: 'content',
  PHOTO: 'photo'
} as const;
export type VideoFocus = (typeof VideoFocus)[keyof typeof VideoFocus];

/** データチャネル イベント */
export const DataMessageEvent = {
  CHANGE_VIDEO_FOCUS: 'change_video_focus' // 画面フォーカス変更要求
};
export type DataMessageEvent = (typeof DataMessageEvent)[keyof typeof DataMessageEvent];

/** 【管理者】操作権限 */
export const CapabilityType = {
  SERVICE: 'service',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LOCATION: 'location',
  ADMIN: 'admin',
  HISTORY: 'history'
} as const;
export type CapabilityType = (typeof CapabilityType)[keyof typeof CapabilityType];

/** 撮影画像 */
export interface PhotoItem {
  photoId: string;
  photo: GetPhoto200Response;
}
